import qs from 'qs'
import { Buffer } from 'buffer'

export const prettyFileSize = (number: number): string => {
  if (number < 1024) {
    return number + ' bytes'
  } else if (number >= 1024 && number < 1048576) {
    return (number / 1024).toFixed(1) + ' KB'
  } else if (number >= 1048576) {
    return (number / 1048576).toFixed(1) + ' MB'
  }
  return ''
}

export const toQueryString = (obj: Record<string, unknown>) =>
  Object.keys(obj)
    // .filter(key =>
    //   Array.isArray(obj[key as keyof typeof obj])
    //     ? (obj[key] as Array<unknown>).length > 0
    //     : obj[key] !== false
    //     ? !!obj[key]
    //     : key
    // )
    .reduce(
      (res: Array<unknown>, x: unknown) => [
        ...res,
        `${x}=${
          Array.isArray(obj[x as keyof typeof obj])
            ? (obj[x as keyof typeof obj] as Array<string>)
                .map((e: unknown) => encodeURIComponent(e as string))
                .join(',')
            : encodeURIComponent(obj[x as keyof typeof obj] as string) || null
        }`
      ],
      []
    )
    .join('&')

export const getQueryStringObject = () =>
  window && window.location && window.location.search ? qs.parse(window.location.search.slice(1)) : {}

export const base64ToBlob = (base64: string, contentType = '', sliceSize = 512) => {
  const byteCharacters = atob(base64.split(',')[1]) // remove base64 prefix
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)
    const byteNumbers = new Array(slice.length)

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  return new Blob(byteArrays, { type: contentType })
}

export const svgStringToBlob = (svgString: string) => {
  const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' })
  return svgBlob
}

export const convertImageToBase64 = async (imageUrl: string): Promise<string | ArrayBuffer | null> => {
  const response = await fetch(imageUrl)
  const blob = await response.blob() // Get the image data as a blob

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      resolve(reader.result) // Base64 string is in reader.result
    }
    reader.onerror = reject
    reader.readAsDataURL(blob) // Read the blob as a data URL (Base64)
  })
}

export const svgToBase64 = async (url: string) => {
  // Fetch the SVG file as text
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Failed to fetch SVG: ${response.statusText}`)
  }
  const svgText = await response.text()

  // Encode the SVG text into Base64 using Buffer
  const base64 = Buffer.from(svgText, 'utf-8').toString('base64')

  // Construct the Base64 data URI
  return `data:image/svg+xml;base64,${base64}`
}

export const measureFormatter = (value: number, market: string, type?: string) => {
  const cm2Output = `${value.toFixed(2)} cm${type === 'area' ? '²' : ''}`
  const conversionFactor = type === 'area' ? 6.4516129 : 2.54
  return market.toUpperCase() === 'USA'
    ? `${(value / conversionFactor).toFixed(2)} in${type === 'area' ? '²' : ''}`
    : cm2Output
}
